import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import { updateCReportProps } from '../../stores/contracting-reports/actions';

const ReportList = (props) => {
  const {
    updateProps,
    contractingReports,
    plan,
  } = props;

  const reports = [
    {
      reportName: 'Progress Report',
      key: 'progress',
    },
    {
      reportName: 'Allocation Report',
      key: 'allotment',
    },
    {
      reportName: 'Blackout Dates',
      key: 'blackout',
    },
  ];

  return (
    <div style={{ display: 'block' }}>
      {
        reports.map((report, i) => {
          const isActive = contractingReports.selectedReport === report.key;
          const className = isActive ? 'report is-active' : 'report';
          return (
            <div
              key={i}
              className={className}
              style={{ padding: '3% 0', marginTop: '5px' }}
              onClick={() => updateProps({ selectedReport: report.key, showSuggestionConfirmation: false })}
            >
              <span
                style={{ color: isActive ? 'rgb(0, 188, 212)' : '#ffffff', fontSize: '14px', marginLeft: '40px' }}
              >
                {report.reportName}
              </span>
            </div>
          );
        })
      }
      <div style={{ marginTop: '60%', cursor: 'pointer' }}>
        <div
          className={contractingReports.selectedReport === 'suggestion' ? 'report is-active' : 'report'}
          style={{ padding: '3% 0', marginTop: '5px' }}
          onClick={() => updateProps({ selectedReport: 'suggestion' })}
        >
          <span style={{ color: contractingReports.selectedReport === 'suggestion' ? '#bdbdbd' : '#ffffff', fontSize: '14px' }}>
            <span style={{ marginLeft: '40px', fontSize: '14px' }}>
              Suggest A Report
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

ReportList.propTypes = {
  updateProps: PropTypes.func,
  contractingReports: PropTypes.object,
  plan: PropTypes.string,
};

const mapDispatchToProps = dispatch => ({
  updateProps: (...args) => dispatch(updateCReportProps(...args)),
});

const mapStateToProps = ({ contractingReports, user }) => ({
  contractingReports: contractingReports.toJS(),
  plan: user.get('billingPlan'),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportList);



// WEBPACK FOOTER //
// ./src/app/components/contracting-reports/reportList.jsx